import React from "react";
import { HiOutlineArrowRightOnRectangle } from "react-icons/hi2";
import LanguageSelector from "../../common/LanguageSelector";
import ThemeToggle from "../../common/ThemeToggle";
import { textPrimary, roundedBtn } from "./designTokens";

export function HeaderActions({ user, handleLogout, t }) {
  return (
    <div className="flex items-center gap-2 shrink-0">
      <LanguageSelector />
      <ThemeToggle />
      {user && (
        <div
          className={`hidden sm:flex items-center gap-2 px-3 py-2 ${roundedBtn} bg-gray-100 dark:bg-gray-700`}
        >
          <div
            className={`w-8 h-8 ${roundedBtn} bg-gray-800 dark:bg-gray-600 text-white flex items-center justify-center text-xs font-bold shrink-0`}
          >
            {user?.first_name?.charAt(0).toUpperCase() ||
              user?.username?.charAt(0).toUpperCase() ||
              "U"}
          </div>
          <span
            className={`text-sm font-medium truncate max-w-[120px] ${textPrimary}`}
          >
            {user?.first_name || user?.username}
          </span>
        </div>
      )}
      <button
        onClick={handleLogout}
        className="hidden sm:flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium text-white bg-white/20 dark:bg-gray-700/50 hover:bg-white/30 dark:hover:bg-gray-600/50 border border-slate-200/50 dark:border-slate-600/50 transition-colors"
      >
        <HiOutlineArrowRightOnRectangle className="w-4 h-4" />
        {t("logout") || "Déconnexion"}
      </button>
    </div>
  );
}
